import React, { useEffect, useState } from "react";
import styles from "./RadioGroup.module.css";

interface Option {
    id: string;
    label: string;
}

interface RadioGroupProps {
    options: Option[];
    name: string;
    defaultValue?: string;
    onChange?: (value: string) => void;
    selectFirstWhenNoValueProvided?: boolean,
    disabled?: boolean
}

const RadioGroup: React.FC<RadioGroupProps> = ({ options, name, defaultValue, onChange, selectFirstWhenNoValueProvided = true, disabled = false }) => {
    const [selected, setSelected] = useState<string>(defaultValue || (selectFirstWhenNoValueProvided ? options[0].id : ''));

    useEffect(() => {
        if (defaultValue) {
            setSelected(defaultValue);
        } else if (selectFirstWhenNoValueProvided && options.length > 0) {
            setSelected(options[0].id);
        }
    }, [defaultValue, options, selectFirstWhenNoValueProvided]);

    const handleChange = (value: string) => {
        if (disabled) return;
        setSelected(value);
        if (onChange) onChange(value);
    };

    return (
        <div className={styles.radioGroup}>
            {options.map((option) => {
                const isChecked = selected === option.id;
                return (
                    <label key={option.id} className={styles.radioLabel}>
                        <input
                            type="radio"
                            name={name}
                            value={option.id}
                            checked={isChecked}
                            onChange={() => handleChange(option.id)}
                            className={styles.radioInput}
                            disabled={disabled}
                        />
                        <span className={`${styles.radioVisual} ${isChecked ? styles.checked : ''}`} />
                        <span className={styles.radioText}>{option.label}</span>
                    </label>
                );
            })}
        </div>
    );
};

export default RadioGroup;